import type { AppConfig } from "../types";

const KEY_CONFIG = "supriai.config.v2";

const DEFAULT: AppConfig = {
  apiUrl: typeof window !== "undefined" && window.location.origin.startsWith("http")
    ? window.location.origin
    : "https://launcher.supricrm.tech",
  apiKey: "",
  qwenModel: "",
};

export function loadConfig(): AppConfig {
  try {
    const raw = localStorage.getItem(KEY_CONFIG);
    if (!raw) return { ...DEFAULT };
    return { ...DEFAULT, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT };
  }
}

export function saveConfig(cfg: AppConfig) {
  localStorage.setItem(KEY_CONFIG, JSON.stringify(cfg));
}
